import { FC, ReactElement, cloneElement } from 'react';
import { ISharePopupInstance } from '@base/lib/share/useSharePopup';
import { IUtmQuery } from 'base/utils/request';
import { IClickShareItem } from '@base/lib/share/interface';
import { isPhone } from 'base/utils/client';
import { SharePopupM, ISharePopupMProps } from '@base/lib/share/SharePopupM';
import { SharePopupPC, ISharePopupPCProps } from '@base/lib/share/SharePopupPC';

type ISharePopupProps = {
    className?: string;
    url?: string;
    shareUrls?: ISharePopupInstance;
    utmQuery?: IUtmQuery;
    trackTargetPrefix?: string; //Ctr 打点
    onClickItem?: (shareChannel?: IClickShareItem) => void;
    needLogin?: boolean;
    trigger: ReactElement;
    afterOpen?: () => void;
    pc?: Partial<ISharePopupPCProps>;
    m?: Partial<ISharePopupMProps>;
};

export const SharePopup: FC<ISharePopupProps> = props => {
    const { pc, m, trigger, ...rest } = props;

    return isPhone ? (
        <SharePopupM {...rest} {...m}>
            {({ open }) => cloneElement(trigger, { onClick: open })}
        </SharePopupM>
    ) : (
        <SharePopupPC {...rest} {...pc}>
            {trigger}
        </SharePopupPC>
    )
};
